module.exports = { id: "nl-product", url: "/build/app/img/symbols.svg#nl-product", viewBox: "", toString: function() { return this.url; } };